import { apiGet, apiPost, apiPut } from "../../../qv4/models/shared/apiClient";

export async function fetchHandover(queryPk) {
  const response = await apiGet(`/operations-v2/handovers/query/${queryPk}`);
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to load the Operations handover.");
  return response.data.data;
}

export async function saveLineAddresses(queryPk, selections) {
  const response = await apiPut(`/operations-v2/handovers/query/${queryPk}/line-addresses`, { selections });
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to save delivery addresses.");
  return response.data.data;
}

export async function submitHandover(payload) {
  const response = await apiPost("/operations-v2/handovers", payload);
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to hand over this order.");
  return response.data;
}

export async function applyApprovedHandover(handoverId) {
  const response = await apiPost(`/operations-v2/handovers/${handoverId}/apply-approved`, {});
  if (!response.data?.success) throw new Error(response.data?.message || "Unable to apply the approved handover.");
  return response.data;
}
